module.exports = __webpack_public_path__ + "static/03-a7723be2e5ca939a5b938afe4d3259a1.jpg";